import axios from "axios";

export default function PartnerListService(query) {
    if(query && query.toString().includes(',"multiSortMeta":[]')) {
    query = query.replace(',"multiSortMeta":[]', '')
  }
    console.log(query)
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/api/v2/partner" + query,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
